import React from "reactn";
import { Icon } from "@material-ui/core";
import styled from "styled-components";

const ErrorPaneStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: -20px;
  border: solid 1px orangered;
  color: orangered;

  .MuiIcon-root {
    font-size: 32px;
    margin-right: 10px;
  }
`;

export default function ErrorPane(props) {
    return (
        <ErrorPaneStyled>
            <Icon>warning</Icon>
            <div>{props.message || props.children}</div>
        </ErrorPaneStyled>
    );
}
